import React from 'react'
import Text from '../../components/text/Text'
import {ICaseVariable} from './types'

interface IProps {
    className?: string
    variables?: ICaseVariable[] // 현재 카테고리의 변수 셋(공통 변수 + 해당 kind 변수). 상위(FeedForm)에서 계약 기반으로 주입
    onSelect: (name: string) => void
    onButtonMouseDown?: (e: React.MouseEvent<HTMLButtonElement>) => void
}

const CHIP_CLASS = 'px-[10px] py-[4px] rounded-[5px] bg-white border border-line02 text-font01 text-ti3 font-bold hover:border-primary'

const VariableChipList: React.FC<IProps> = ({className, variables, onSelect, onButtonMouseDown}) => {
    const list = variables ?? []

    return (
        <div className={`flex items-center gap-x-[6px] gap-y-[6px] flex-wrap ${className}`}>
            <Text className={'text-ti3 text-font03 whitespace-nowrap'}>변수 삽입:</Text>
            {list.map(variable => (
                <button
                    key={variable.name}
                    type={'button'}
                    title={variable.description}
                    onMouseDown={onButtonMouseDown}
                    onClick={() => onSelect(variable.name)}
                    className={CHIP_CLASS}>
                    {`{${variable.name}}`}
                </button>
            ))}
        </div>
    )
}

export default VariableChipList
